import * as XLSX from 'xlsx'
export default class ExcelHelp{
  /**
   * 单个sheet下载
   * @param {object[]} json json
   * @param {object} tableTitle excel表头名称
   * @param {string} fileName 文件名称
   * @param {object} wbConfig 扩展
   * @param {object} woptsConfig 扩展
   */
  static json2Excel(json,tableTitle,fileName,wbConfig={},woptsConfig={}) {
    let wopts = {
      bookType: 'xlsx',
      bookSST: false,
      type: 'binary'
    };
    let workBook = {
      SheetNames: ['Sheet1'],
      Sheets: {},
      Props: {}
    };
    json = [tableTitle,...json];
    workBook.Sheets['Sheet1'] = XLSX.utils.json_to_sheet(json,{skipHeader:true}); // skipHeader 忽略原来的表头

    //3、XLSX.write() 开始编写Excel表格
    //4、changeData() 将数据处理成需要输出的格式
    ExcelHelp.saveAs(new Blob([ExcelHelp.changeData(XLSX.write({...workBook,...wbConfig}, {...wopts,...woptsConfig}))], {type: 'application/octet-stream'}),fileName)
  }
  static changeData(s) {

    //如果存在ArrayBuffer对象(es6) 最好采用该对象
    if (typeof ArrayBuffer !== 'undefined') {

      //1、创建一个字节长度为s.length的内存区域
      let buf = new ArrayBuffer(s.length);

      //2、创建一个指向buf的Unit8视图，开始于字节0，直到缓冲区的末尾
      let view = new Uint8Array(buf);

      //3、返回指定位置的字符的Unicode编码
      for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;

    } else {
      let buf = new Array(s.length);
      for (let i = 0; i !== s.length; ++i) buf[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }
  }
  static saveAs(obj, fileName) {//当然可以自定义简单的下载文件实现方式
    let tmpa = document.createElement("a");
    tmpa.download = fileName+'.xlsx' || "下载.xlsx";
    tmpa.href = URL.createObjectURL(obj); //绑定a标签
    tmpa.click(); //模拟点击实现下载

    setTimeout(function () { //延时释放
      URL.revokeObjectURL(obj); //用URL.revokeObjectURL()来释放这个object URL
    }, 100);
  }

  static importFile(callback,rABS=true){
    let upload=document.getElementById("uploadFile-9999");
    if(!upload){
      upload=document.createElement('input');
      upload.type="file";
      upload.id="uploadFile-9999";
      upload.style.display="none";
    }
    upload.click();
    upload.onchange=function (e) {
      // let formData = new FormData();
      // formData.append("file",this.files[0]);
      ExcelHelp._importFile(this,callback,rABS)

      upload.onchange=undefined;

    }

  }
  static _importFile(fileObj,callback,rABS=true) {//导入
    if (!fileObj.files) {
      return;
    }
    let f = fileObj.files[0];
    let reader = new FileReader();
    reader.onload = function (e) {
      let data = e.target.result;
      let wb=null;
      if (rABS) {
        wb = XLSX.read(btoa(ExcelHelp.fixdata(data)), {//手动转化
          type: 'base64'
        });
      } else {
        wb = XLSX.read(data, {

          type: 'binary'//以二进制的方式读取
        });
      }

      console.log('wb: ', wb);
      //wb.SheetNames[0]是获取Sheets中第一个Sheet的名字
      //wb.Sheets[Sheet名]获取第一个Sheet的数据
      // XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], { raw: false }); //以字符串形式读取。
      // console.log('XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]): ', XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]));
      // document.getElementById("demo").innerHTML = JSON.stringify(XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]));

      typeof callback==="function"&&callback(XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], { raw: false }))

    };
    if (rABS) {
      reader.readAsArrayBuffer(f);
    } else {
      reader.readAsBinaryString(f);
    }
  }


  static fixdata(data) { //文件流转BinaryString
    var o = "",
      l = 0,
      w = 10240;
    for (; l < data.byteLength / w; ++l) o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w, l * w + w)));
    o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
    return o;
  }
}



// WEBPACK FOOTER //
// ./src/components/Admin/EnergyConsumption/common/ExcelHelp.js